import { useCallback, useEffect, useState } from "react";
import { SiMeta } from "react-icons/si";

import { CarregandoBloco, CarregandoCards } from "@/components/carregando";
import { possoAgora, temAcessoTotal, usuarioLogado } from "@/lib/permissoes";

import { anunciosMetaApi } from "./api";
import Conectada from "./Conectada";
import NaoConectada from "./NaoConectada";
import PassoConexao from "./PassoConexao";

/**
 * IMPULSIONE -> Anúncios Meta (plano em docs/features/meta-ads).
 * Três estados: não conectada (o que precisa + botão), conectando (passo a
 * passo com o ID do portfólio da loja) e conectada (o que está ligado, o que
 * falta para o anúncio vender, resultado, área do anúncio e ajustes).
 */
export default function AnunciosMetaPage() {
  const [situacao, setSituacao] = useState(null);
  const [erro, setErro] = useState(null);
  const [conectando, setConectando] = useState(false);
  const [dias, setDias] = useState(30);
  const [campanhas, setCampanhas] = useState(null);
  // A mesma regra do servidor: campanhas, área e imposto são de quem tem
  // Impulsione; conectar e desfazer a conexão, só de dono e administrador.
  const podeGerir = possoAgora("impulsione");
  const podeConectar = temAcessoTotal(usuarioLogado());

  const carregar = useCallback(async () => {
    try { setSituacao(await anunciosMetaApi.situacao()); setConectando(false); }
    catch { setErro("Não foi possível carregar a situação da conexão."); }
  }, []);
  useEffect(() => { carregar(); }, [carregar]);

  const conectada = situacao?.situacao === "conectada";
  useEffect(() => {
    if (!conectada) return;
    anunciosMetaApi.campanhas(dias).then(setCampanhas).catch(() => setCampanhas(null));
  }, [conectada, dias, situacao?.conexao?.ultimo_sync_em]);

  return (
    <div className="p-4 sm:p-6">
      <div className="max-w-6xl mx-auto space-y-5" data-e2e="anuncios-meta">
        <div className="flex items-center gap-3 min-w-0">
          <div className="w-12 h-12 rounded-xl flex items-center justify-center shrink-0 bg-sky-500/10 text-sky-500">
            <SiMeta className="w-6 h-6" />
          </div>
          <div className="min-w-0">
            <h1 className="text-2xl font-bold leading-tight">Anúncios Meta</h1>
            <p className="text-sm text-muted-foreground mt-0.5">
              Anuncie no Instagram e no Facebook e veja aqui quanto cada campanha gastou e quanto vendeu.
            </p>
            {situacao && !situacao.configurado && (
              <p className="mt-1 text-xs text-amber-600">A integração ainda não foi ativada neste servidor. Fale com o suporte do Núcleo.</p>
            )}
          </div>
        </div>

        {erro ? (
          <p className="text-destructive">{erro}</p>
        ) : !situacao ? (
          // Carregamento com cards (25/10/2026): título na hora; a situação da conexão pisca até chegar.
          <div className="space-y-5">
            <CarregandoBloco altura="h-28" />
            <CarregandoCards quantos={4} />
            <CarregandoBloco altura="h-56" />
          </div>
        ) : conectada ? (
          <Conectada situacao={situacao} campanhas={campanhas} dias={dias} onDias={setDias} podeGerir={podeGerir} podeConectar={podeConectar} onMudou={carregar} />
        ) : conectando ? (
          <PassoConexao nucleoBusinessId={situacao.nucleo_business_id} onConectado={carregar} onCancelar={() => setConectando(false)} />
        ) : (
          <NaoConectada situacao={situacao.situacao} podeGerir={podeConectar && situacao.configurado} onComecar={() => setConectando(true)} />
        )}
      </div>
    </div>
  );
}
